import React from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';

import {
  styled, Box, FormGroup, FormControlLabel, SvgIcon,
} from '@mui/material';
import CheckboxMui from '@mui/material/Checkbox';

import { useFormContext } from '../../../contexts/form';

import { styles } from './styles';

export const IconUnchecked = (props) => (
  <SvgIcon viewBox="0 0 15 16" {...props}>
    <rect x="0.499512" y="1" width="14" height="14" rx="3.5" fill="#ffffff" stroke="#B2B2B2" />
  </SvgIcon>
);

export const IconChecked = (props) => (
  <SvgIcon viewBox="0 0 15 16" {...props}>
    <rect x="-0.000488281" y="0.5" width="15" height="15" rx="4" fill="#2845D2" />
    <path d="M5.83284 11.9167L2.49951 8.58333L3.66618 7.41666L5.83284 9.58333L11.3328 4.08333L12.4995 5.24999L5.83284 11.9167Z" fill="white" />
  </SvgIcon>
);

export const IconIndeterminate = (props) => (
  <SvgIcon viewBox="0 0 15 16" {...props}>
    <rect x="0.499512" y="1" width="14" height="14" rx="3.5" stroke="#B2B2B2" fill="#FFFFFF" />
    <path d="M3.99951 8.69999V7.29999H10.9995V8.69999H3.99951Z" fill="#7B7B7B" />
  </SvgIcon>
);

const CheckboxRaw = ({
  name, checked, onChangeCheckbox, required, className, children, label, indeterminate, disabled,
}) => {
  const { formRegister, formErrors } = useFormContext();

  const controlLabel = children;

  const register = formRegister(name, {
    required: {
      value: required,
      message: `${t(label)} ${t('IS REQUIRED')}`,
    },
  });

  return (
    <Box className={`${className} DN-Checkbox ${formErrors[name] ? 'dn-error' : ''} ${checked ? 'dn-checked' : 'dn-unchecked'}`}>
      <FormGroup>
        <FormControlLabel
          control={(
            <Box className="dn-checkbox-wrapper">
              <CheckboxMui
                checked={checked}
                indeterminate={indeterminate}
                name={name}
                required={required}
                icon={<IconUnchecked />}
                checkedIcon={<IconChecked />}
                indeterminateIcon={<IconIndeterminate />}
                disabled={disabled}
                {...register}
                onChange={(e) => {
                  register.onChange(e);
                  onChangeCheckbox(e);
                }}
              />
            </Box>
          )}
          label={controlLabel}
          labelPlacement="end"
        />
      </FormGroup>
    </Box>
  );
};

CheckboxRaw.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  className: PropTypes.string,
  onChangeCheckbox: PropTypes.func,
};

const Checkbox = styled(CheckboxRaw)(styles);

Checkbox.propTypes = CheckboxRaw.propTypes;

export default Checkbox;
